import DetailsSkeleton from '@/features/dashboard/bookingChanges/components/DetailsSkeleton.tsx';
import { ClientBillViewSkeleton } from '@/features/dashboard/bookingChanges/components/bill';

/**
 * `pendingComponent` ekranu osoby zapisującej — trzy zakładki i dane płatnika
 * w kolumnie treści, bo wejście zawsze zaczyna się od „Informacji”.
 */
const ClientDetailsSkeleton = () => (
  <DetailsSkeleton tabCount={2}>
    <ClientBillViewSkeleton />
  </DetailsSkeleton>
);

export default ClientDetailsSkeleton;
